import SquircleDiv from "../common/SquircleDiv";
import { ChevronRight } from "lucide-react";
import moment from "moment";
import { useSelector } from "react-redux";


const DateFilters = ({getOrderData,formData, setFormData }) => {
  const isGray= false

  const fyearInfo = useSelector((store) => store?.user?.fyearInfo);

  const getDateRange = (days) => {
    const to = new Date(); // today
    const from = moment(new Date()).subtract(days, "days"); // days before today

    setFormData((prev)=>({...prev,
      from: moment(from).format("YYYY-MM-DD"),
      to: moment(to).format("YYYY-MM-DD")
    }));

    getOrderData({...formData,
      from: from,
      to: to,
    })
  };

  const getFyearDateRange=()=>{
    if(!fyearInfo || !fyearInfo.fdate || !fyearInfo.tdate){
      console.log('User Information not found');
      
    }
    
    getOrderData({...formData,
      from: moment(fyearInfo.fdate, "YYYY-MM-DD").toISOString(),
      to: moment(fyearInfo.tdate, "YYYY-MM-DD").toISOString()
    })
  }

  const handleGoClick=()=>{
    getOrderData(formData);
  }


  return (
    <div className="flex flex-wrap gap-6 items-center lg:px-2">
      <div className="w-44 cursor-pointer" onClick={() => getDateRange(15)}>
        <SquircleDiv squircle={5} shadowColor="rgba(0,0,0,0.05)" borderColor={isGray? "#313131b9":"rgba(0,0,0,0)"} className={`${isGray ?"bg-[#282828]" : ""}`}>
          <div className={`flex items-center my-2 gap-4 pr-2 `}>
            <div
              className="w-1 bg-[#8833FF] h-7"
              style={{ borderRadius: "0px 5px 5px 0px" }}
            ></div>
            <p
              className={`w-8 h-8 rounded-full shadow-lg flex items-center justify-center text-[#8833FF] text-sm font-semibold
                ${isGray ? "border-2 border-[#4d4c4c]" : ""}`}
              style={{ boxShadow: "0px 0px 5px 5px rgba(0,0,0,0.06)" }}
            >
              15
            </p>
            <p className={`${isGray ? "text-[#DBE2F2]":"text-[#4d5e80]"} text-sm font-roboto font-semibold`}>DAYS</p>
            <div>
              <ChevronRight size={18} className={`${isGray ? "text-[#ffffff]":"text-[#4d5e80]"}`} />
            </div>
          </div>
        </SquircleDiv>
      </div>

      <div className="w-44 cursor-pointer" onClick={() => getDateRange(30)}>
        <SquircleDiv squircle={5} shadowColor="rgba(0,0,0,0.05)" borderColor={isGray? "#313131b9":"rgba(0,0,0,0)"} className={`${isGray ?"bg-[#282828]" : ""}`}>
          <div className="flex items-center my-2 gap-4 pr-2">
            <div
              className="w-1 bg-[#29CC39] h-7"
              style={{ borderRadius: "0px 5px 5px 0px" }}
            ></div>
            <p
              className={`w-8 h-8 rounded-full shadow-lg flex items-center justify-center text-[#29CC39] text-sm font-semibold
                ${isGray ? "border-2 border-[#4d4c4c]" : ""}`}
              style={{ boxShadow: "0px 0px 5px 5px rgba(0,0,0,0.06)" }}
            >
              30
            </p>
            <p className={`${isGray ? "text-[#DBE2F2]":"text-[#4d5e80]"} text-sm font-roboto font-semibold`}>DAYS</p>
            <div>
              <ChevronRight size={18} className={`${isGray ? "text-[#ffffff]":"text-[#4d5e80]"}`} />
            </div>
          </div>
        </SquircleDiv>
      </div>

      <div className="min-w-44 cursor-pointer" onClick={() => getDateRange(180)}>
        <SquircleDiv squircle={5} shadowColor="rgba(0,0,0,0.05)" borderColor={isGray? "#313131b9":"rgba(0,0,0,0)"} className={`${isGray ?"bg-[#282828]" : ""}`}>
          <div className="flex items-center my-2 gap-4 pr-2">
            <div
              className="w-1 bg-[#FFBE00] h-7"
              style={{ borderRadius: "0px 5px 5px 0px" }}
            ></div>
            <p
              className={`w-8 h-8 rounded-full shadow-lg flex items-center justify-center text-[#FFBE00] text-sm font-semibold
                ${isGray ? "border-2 border-[#4d4c4c]" : ""}`}
              style={{ boxShadow: "0px 0px 5px 5px rgba(0,0,0,0.06)" }}
            >
              180
            </p>
            <p className={`${isGray ? "text-[#DBE2F2]":"text-[#4d5e80]"} text-sm font-roboto font-semibold`}>DAYS</p>
            <div>
              <ChevronRight size={18} className={`${isGray ? "text-[#ffffff]":"text-[#4d5e80]"}`} />
            </div>
          </div>
        </SquircleDiv>
      </div>

      <div className="min-w-44 cursor-pointer" onClick={getFyearDateRange}>
        <SquircleDiv squircle={5} shadowColor="rgba(0,0,0,0.05)" borderColor={isGray? "#313131b9":"rgba(0,0,0,0)"} className={`${isGray ?"bg-[#282828]" : ""}`}>
          <div className="flex items-center my-2.5 gap-4 pr-2">
            <div
              className="w-1 bg-[#33bfff] h-7"
              style={{ borderRadius: "0px 5px 5px 0px" }}
            ></div>
            <p className={`${isGray ? "text-[#DBE2F2]":"text-[#4d5e80]"} text-sm font-roboto font-semibold`}>
              FINANCIAL YEAR
            </p>
            <div>
              <ChevronRight size={18} className={`${isGray ? "text-[#ffffff]":"text-[#4d5e80]"}`} />
            </div>
          </div>
        </SquircleDiv>
      </div>

      <div className="w-24 cursor-pointer" onClick={handleGoClick}>
        <SquircleDiv squircle={5} shadowColor="rgba(0,0,0,0.05)" borderColor={isGray? "#313131b9":"rgba(0,0,0,0)"} className={`${isGray ?"bg-[#282828]" : ""}`}>
          <div className="flex items-center my-2.5 gap-4 pr-2">
            <div
              className="w-1 bg-[#c7c7cc] h-7"
              style={{ borderRadius: "0px 5px 5px 0px" }}
            ></div>
            <p className={`${isGray ? "text-[#DBE2F2]":"text-[#4d5e80]"} text-sm font-roboto font-semibold`}>
              GO
            </p>
            <div>
              <ChevronRight size={18} className={`${isGray ? "text-[#ffffff]":"text-[#4d5e80]"}`} />
            </div>
          </div>
        </SquircleDiv>
      </div>
    </div>
  );
};

export default DateFilters;

